import * as React from 'react';
import { useSelector } from 'react-redux';

import { chatListSelector } from '../selectors';

export const useOpponentByChatId = (): ((chatId: string) => number | undefined) => {
  const { chats } = useSelector(chatListSelector);

  return React.useCallback(
    (chatId: string) => {
      const chat = chats.find(chat => chat.chatId === chatId);
      const { users } = chat || {};
      const opponent = users?.find(user => user.chatRole === 'opponent');

      return opponent ? opponent.userId : undefined;
    },
    [chats],
  );
};
